/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import { queryOptions, useQuery } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  FindOperationChainsQueryResponse,
  FindOperationChainsQueryParams,
} from "../types/FindOperationChains.ts"

export const findOperationChainsQueryKey = (
  params?: FindOperationChainsQueryParams
) =>
  [
    { url: "/v1/operation-chain/find-operation-chains" },
    ...(params ? [params] : []),
  ] as const

export type FindOperationChainsQueryKey = ReturnType<
  typeof findOperationChainsQueryKey
>

/**
 * @summary Find operation chains
 * {@link /v1/operation-chain/find-operation-chains}
 */
export async function findOperationChains(
  params?: FindOperationChainsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindOperationChainsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/operation-chain/find-operation-chains`,
    params,
    ...requestConfig,
  })
  return res
}

export function findOperationChainsQueryOptions(
  params?: FindOperationChainsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = findOperationChainsQueryKey(params)
  return queryOptions<
    ResponseConfig<FindOperationChainsQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindOperationChainsQueryResponse>,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return findOperationChains(params, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary Find operation chains
 * {@link /v1/operation-chain/find-operation-chains}
 */
export function useFindOperationChains<
  TData = ResponseConfig<FindOperationChainsQueryResponse>,
  TQueryData = ResponseConfig<FindOperationChainsQueryResponse>,
  TQueryKey extends QueryKey = FindOperationChainsQueryKey,
>(
  params?: FindOperationChainsQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindOperationChainsQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ?? findOperationChainsQueryKey(params)

  const query = useQuery(
    {
      ...findOperationChainsQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
